import { render, staticRenderFns } from "./MyContent.vue?vue&type=template&id=28dc48b5&scoped=true&"
import script from "./MyContent.vue?vue&type=script&lang=js&"
export * from "./MyContent.vue?vue&type=script&lang=js&"
import style0 from "./MyContent.vue?vue&type=style&index=0&id=28dc48b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dc48b5",
  null
  
)

export default component.exports